import { IResult } from '../models/result-models';
import { apiGet, apiPut } from './api-utils';
import { ICartItemInfo, IUpdateItemQuantityRequest } from '../models/pro-sites';
import { CartType } from '../models/cart-type-enum';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/cart';

export const getSavedCart = async (): Promise<IResult<ICartItemInfo[]>> => {
    const result = await apiGet<ICartItemInfo[]>(baseUrl + '/saved');
    return result;
};

export const moveItemFromPrimaryCartToSavedCart = async (
    lineItemId: string
): Promise<IResult<ICartItemInfo[]>> => {
    const result = await apiPut<string, ICartItemInfo[]>(
        baseUrl + '/move-primary-to-saved',
        lineItemId
    );
    return result;
};

export const moveItemFromSavedCartToPrimaryCart = async (
    lineItemId: string
): Promise<IResult<ICartItemInfo[]>> => {
    const result = await apiPut<string, ICartItemInfo[]>(
        baseUrl + '/move-saved-to-primary',
        lineItemId
    );
    return result;
};

export const updateItemQuantity = async (
    request: IUpdateItemQuantityRequest
): Promise<IResult<number>> => {
    const result = await apiPut<IUpdateItemQuantityRequest, number>(
        baseUrl + '/update-item-quantity',
        request
    );
    return result;
};

export const clear = async (cartType: CartType): Promise<IResult<boolean>> => {
    const result = await apiPut<null, boolean>(
        baseUrl + '/clear/' + cartType,
        null
    );
    return result;
};

export const punchout = async (): Promise<IResult<string[][]>> => {
    const result = await apiGet<string[][]>(baseUrl + '/punchout');
    return result;
};
